import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

export default function Card({ children, className = '', onClick }: CardProps) {
  const baseClasses = 'bg-white rounded-xl shadow-sm border border-gray-100 p-4 md:p-6';
  const interactiveClasses = onClick 
    ? 'cursor-pointer hover:shadow-lg hover:border-gray-200 transition-all duration-200 active:scale-[0.98]' 
    : '';

  return (
    <div
      className={`${baseClasses} ${interactiveClasses} ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
}


